import { loadable } from '../../common/utils/lazyLoading';
import structure from './structures/menu';
const EContentPage = loadable(() => import('./EContentPage'));
export default {
    id: 'e_content',
    title: 'eContent',
    icon: 'books',
    route: 'e-content',
    defaultRoute: 'e-content/libraries',
    component: EContentPage,
    group: 'administration',
    structure,
};
